import { Skeleton, TableCell, TableRow } from "@mui/material";

type TableSkeletonRowsProps = {
  rows?: number;
  columns: number;
};

/** Linhas de skeleton usadas durante o carregamento, padrão visual da Auditoria. */
export function TableSkeletonRows({ rows = 10, columns }: TableSkeletonRowsProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <TableRow key={`skeleton-${i}`}>
          {Array.from({ length: columns }).map((__, j) => (
            <TableCell key={j}>
              <Skeleton variant="text" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

export default TableSkeletonRows;
